import styles from './DataTable.module.css';

export interface Column<T> {
    key: keyof T | string;
    header: string;
    render?: (value: any, row: T) => React.ReactNode;
}

export interface DataTableProps<T> {
    data: T[];
    columns: Column<T>[];
    loading?: boolean;
}

export const DataTable = <T extends Record<string, any>>({
    data,
    columns,
    loading = false,
}: DataTableProps<T>) => {
    if (loading) {
        return <div className={styles['data-table-loading']}>Cargando...</div>;
    }

    return (
        <div className={styles['data-table']}>
            <table>
                <thead>
                    <tr>
                        {columns.map((column) => (
                            <th key={String(column.key)}>{column.header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.length === 0 ? (
                        <tr>
                            <td colSpan={columns.length} className={styles['data-table-empty']}>
                                No hay datos disponibles
                            </td>
                        </tr>
                    ) : (
                        data.map((row, index) => (
                            <tr key={index}>
                                {columns.map((column) => {
                                    const value = row[column.key as keyof T];
                                    return (
                                        <td key={String(column.key)}>
                                            {column.render ? column.render(value, row) : String(value ?? '')}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};
